import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ShareOption } from './share.model';

@Component({
  selector: 'fz-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss'],
})
export class ShareComponent {
  @Input() shareOptions: ShareOption[];
  @Input() profileLink: string;
  @Input() shareLabel: string;

  /**
   * @deprecated
   */
  @Input() isZbo: boolean;
  @Output() shareBy: EventEmitter<string> = new EventEmitter();

  onEvent(item: string) {
    this.shareBy.emit(item);
  }
}
